import React from "react";
import OrderListCommonLayer from "./OrderListCommonLayer";

const AllOrdersLayer = () => {
    return (
        <OrderListCommonLayer 
            pageTitle="All Orders" 
            categoryStatus="" 
            categoryPayStatus="" 
        />
    );
};

export default AllOrdersLayer;
